<template>
    <div class="side-menu-wrapper"
        :style="{marginRight: '-' + scrollBarSize + 'px'}">
        <slot></slot>
        <Menu ref="menu"
            v-show="!collapsed"
            :active-name="activeName"
            :open-names="openedNames"
            :accordion="accordion"
            :theme="theme"
            width="auto"
            @on-select="handleSelect">
            <template v-for="item in menuList">
                <template v-if="item.children && item.children.length === 1">
                    <side-menu-item v-if="showChildren(item)"
                        :key="`menu-${item.name}`"
                        :iconSize="iconSize"
                        :parent-item="item"></side-menu-item>
                    <menu-item v-else
                        :name="getName(item, true)"
                        :key="`menu-${item.children[0].name}`">
                        <common-icon class="side-menu-item-icon"
                            :type="item.children[0].icon || ''"
                            :size="iconSize" /><span>{{ showTitle(item.children[0]) }}</span>
                    </menu-item>
                </template>
                <template v-else>
                    <side-menu-item v-if="showChildren(item)"
                        :key="`menu-${item.name}`"
                        :iconSize="iconSize"
                        :parent-item="item"></side-menu-item>
                    <menu-item v-else
                        :name="getName(item)"
                        :key="`menu-${item.name}`">
                        <common-icon class="side-menu-item-icon"
                            :type="item.icon || ''"
                            :size="iconSize" /><span>{{ showTitle(item) }}</span>
                    </menu-item>
                </template>
            </template>
        </Menu>
        <div class="menu-collapsed"
            v-show="collapsed"
            :list="menuList">
            <template v-for="(item, key) in menuList">
                <collapsed-menu v-if="item.children && item.children.length > 1"
                    @on-click="handleSelect"
                    hide-title
                    :root-icon-size="rootIconSize"
                    :icon-size="iconSize"
                    :theme="theme"
                    :parent-item="item"
                    :key="`drop-menu-${item.name}`"></collapsed-menu>
                <Tooltip transfer
                    v-else
                    :content="(item.meta && item.meta.title) || (item.children && item.children[0] && item.children[0].meta.title)"
                    placement="right"
                    :key="`drop-menu-${key}`">
                    <a @click="handleSelect(getName(item, true))"
                        class="drop-menu-a"
                        :style="{textAlign: 'center'}">
                        <common-icon :size="rootIconSize"
                            :color="textColor"
                            :type="item.icon || (item.children && item.children[0].icon)" />
                    </a>
                </Tooltip>
            </template>
        </div>
    </div>
</template>
<script>
import { getScrollBarSize } from 'ivux/src/utils/assist'
import SideMenuItem from './side-menu-item.vue'
import CollapsedMenu from './collapsed-menu.vue'
import { setUnion } from '_u/helper'
import mixin from './mixin'

export default {
    name: 'SideMenu',
    mixins: [mixin],
    components: {
        SideMenuItem,
        CollapsedMenu
    },
    props: {
        menuList: {
            type: Array,
            default () {
                return []
            }
        },
        collapsed: {
            type: Boolean
        },
        theme: {
            type: String,
            default: 'main'
        },
        rootIconSize: {
            type: Number,
            default: 20
        },
        iconSize: {
            type: Number,
            default: 16
        },
        accordion: Boolean,
        activeName: {
            type: String,
            default: ''
        },
        openNames: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            openedNames: [],
            scrollBarSize: getScrollBarSize()
        }
    },
    methods: {
        handleSelect(name) {
            this.$emit('on-select', name)
        },
        getOpenedNamesByActiveName(name) {
            var route = this.$route
            var openedMenus = this.$store.getters.getOpenedMenuList(route)

            return openedMenus.map(item => item.name).filter(item => item !== name)
        },
        updateOpenName(name) {
            if (this.accordion) this.openedNames = this.getOpenedNamesByActiveName(name)
            else this.openedNames = setUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
        }
    },
    computed: {
        textColor() {
            return this.theme === 'main' ? this.variables.menuMainItemColor : '#fff' 
        }
    },
    watch: {
        activeName(name) {
            this.updateOpenName(name)
        },
        openNames(newNames) {
            this.openedNames = newNames
        },
        openedNames() {
            this.$nextTick(() => {
                this.$refs.menu.updateOpened()
            })
        }
    },
    mounted() {
        this.openedNames = setUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
    }
}

</script>
<style lang="less">
@import './side-menu.less';

</style>
